class IntroModal
  @init: () ->
    if localStorage.getItem('seen_introToHomePage') != 'true' && window.innerWidth >= 640
      $('#introToHomepage').foundation('open')
      $('#introToHomepage').on 'closed.zf.reveal', ->
        localStorage.setItem('seen_introToHomePage', 'true')

export default IntroModal
